import { Injectable } from '@angular/core';
@Injectable()
export class FreeGoodsUtilityService {

  constructor() { }

  getColor(outcome) {
    switch (outcome.toLowerCase()) {
      case 'pending':
      case 'pending recertification':
        return 'yellow';
      case 'approved':
        return 'green';
      case 'rejected':
        return 'red';
      default:
          return 'grey';
    }
  }
}